import get from 'lodash.get';
import * as Sentry from '@sentry/browser';

import { ROOT_DOMAIN } from '../constants/app';

const SENTRY_URL = window.config.REACT_APP_SENTRY_URL;
const SENTRY_RELEASE = window.config.REACT_APP_SENTRY_RELEASE;

const config = {
  'glassnode.com': {
    environment: 'Production',
    enabled: true,
  },
  'glassnode.ninja': {
    environment: 'Staging/Ninja',
    enabled: false,
  },
  'glassnode.tech': {
    environment: 'Staging/Tech',
    enabled: false,
  },
};

export const initSentry = () => {
  const { environment, enabled } = get(config, ROOT_DOMAIN, {});

  if (enabled) {
    Sentry.init({ dsn: SENTRY_URL, release: SENTRY_RELEASE, environment });
  }
};
